import { titleize } from 'inflection';
import { dollarSignify } from 'buyside/util/textHelpers';

export const chunk = (input: Array<any>, size: number): Array<Array<any>> =>
  input.reduce(
    (memo, item, idx) =>
      idx % size === 0 ? [...memo, [item]] : [...memo.slice(0, -1), [...memo.slice(-1)[0], item]],
    []
  );

export const labelize = (
  values: string[],
  titleizeLabel?: boolean
): { label: string; value: string }[] =>
  values.map(value => ({
    label: titleizeLabel ? titleize(value) : value,
    value
  }));

export const labelizeWithDollarSign = (values: string[]): { label: string; value: string }[] =>
  values.map(value => ({
    label: dollarSignify(value),
    value: value
  }));

type Truthy<T> = T extends false | '' | null | undefined ? never : T;
export const truthy = <T>(value: T): value is Truthy<T> => !!value;
